import { render } from "./Conferences.vue?vue&type=template&id=4f3f559e"
import script from "./Conferences.vue?vue&type=script&lang=js"
export * from "./Conferences.vue?vue&type=script&lang=js"

import "./Conferences.vue?vue&type=style&index=0&id=4f3f559e&lang=css"
script.render = render

export default script